export const subMenuRouteList = [
];

export const routeMap = {
  '/ai/gpt': 'ff.ai.gpt',
  '/ai/chat': 'ff.ai.chat',
  '/ai/image': 'ff.ai.image',
  '/ai/video': 'ff.ai.video',
  '/ai/whisk': 'ff.ai.whisk',
  '/toolkit/prompt/image': 'ff.toolkit.imageprompt',
  '/toolkit/prompt/video': 'ff.toolkit.videoprompt',
  '/toolkit/search/xhs': 'ff.toolkit.xhssearch',
  '/toolkit/search/dy': 'ff.toolkit.dysearch',
  '/toolkit/hotlist': 'ff.toolkit.hot',
  '/agent/dashboard': 'ff.agent',
  '/agent/generate': 'ff.agent',
  '/agent/history': 'ff.agent',
  '/xhs/agent/dashboard': 'ff.xhsnote',
  '/xhs/agent/generate': 'ff.xhsnote',
  '/xhs/agent/history': 'ff.xhsnote',
  '/xhs/strategoy/diagnose/list': 'ff.xhsstrategy.diagnose',
  '/xhs/strategoy/diagnose/generate': 'ff.xhsstrategy.diagnose',
  '/xhs/strategoy/proposal/list': 'ff.xhsstrategy.proposal',
  '/xhs/strategoy/proposal/generate': 'ff.xhsstrategy.proposal',

  '/xhs/kol/dashboard/view': 'ff.kol.dashboard',
  '/xhs/kol/account/diagnosis': 'ff.kol.account.diagnosis',
  '/xhs/kol/account/analysis': 'ff.kol.account.analysis',
  '/xhs/kol/account/position': 'ff.kol.account.position',
  '/xhs/kol/strategy/matrix': 'ff.kol.strategy.matrix',
  '/xhs/kol/strategy/icebreaker': 'ff.kol.strategy.icebreaker',
  '/xhs/kol/strategy/calendar': 'ff.kol.strategy.calendar',
  '/xhs/kol/strategy/simulator': 'ff.kol.strategy.simulator',
  '/xhs/kol/inspiration/trend': 'ff.kol.inspiration.trend',
  '/xhs/kol/inspiration/template': 'ff.kol.inspiration.template',
  '/xhs/kol/inspiration/keyword': 'ff.kol.inspiration.keyword',
  '/xhs/kol/inspiration/audience': 'ff.kol.inspiration.audience',
  '/xhs/kol/toolbox/rewrite': 'ff.kol.toolbox.rewrite',
  '/xhs/kol/toolbox/keyword': 'ff.kol.toolbox.keyword',
  '/xhs/kol/toolbox/image': 'ff.kol.toolbox.image',
  '/xhs/kol/toolbox/video': 'ff.kol.toolbox.video',
  '/xhs/kol/toolbox/dy': 'ff.kol.toolbox.dy',
  '/xhs/kol/toolbox/check': 'ff.kol.toolbox.check',
  '/xhs/kol/operation/grow': 'ff.kol.operation.grow',
  '/xhs/kol/operation/review': 'ff.kol.operation.review',
  '/xhs/kol/operation/comment': 'ff.kol.operation.comment',
  '/xhs/kol/operation/engagement': 'ff.kol.operation.engagement',
  '/xhs/kol/operation/fan': 'ff.kol.operation.fan',
  '/xhs/kol/asset/visual': 'ff.kol.asset.visual',
  '/xhs/kol/asset/inspiration': 'ff.kol.asset.inspiration',
  '/xhs/kol/asset/draft': 'ff.kol.asset.draft',

  '/owner/transform': 'ff.owner.transform',
}

export const routeWhiteList = [
  '/404',
];

export const directPath = [
  '/help/xhs/auth',
  '/account/info',
]
export const loginDirectPath = [
  '/',
  '/home',
  '/forbidden',
  '/test'
]

export default {
  subMenuRouteList,
  routeWhiteList,
  directPath,
  loginDirectPath
};